/**
 * index.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export { Connection } from "./connection";

export { CompositeConnection } from "./composite-connection";
export { EMPTY, EmptyConnection } from "./empty-connection";
export { MockConnection } from "./mock-connection";
export { WebSocketConnection } from "./websocket-connection";

export { DownloadSocket, SocketFile } from "./download-socket";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/connection/index.ts